var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:['users_list__content', { 'modal_search_content' : _vm.props.isModal } ]},[_c('div',{class:['users_list_inside', { 'modal_user_list' : _vm.props.isModal }]},[_vm._t("header"),_vm._v(" "),_vm._t("content")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-579bd577","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/shared/GenericList.vue
// module id = null
// module chunks = 